import useDuplicateScanService from '../duplicateScanService';
import { UpdateForm } from 'framework/form';
import CandidateDuplicateScanProcessLayout from './CandidateDuplicateScanProcessLayout';

const CandidateDuplicateScanProcessPage = () => {
  const { getById, process, redirectCallback } = useDuplicateScanService();

  return (
    <UpdateForm
      submitFormFunc={process}
      getDataFunc={getById}
      getValidationSchemaFunc={() => Promise.resolve({})}
      afterSubmit={{
        execute: () => {
          return redirectCallback();
        },
      }}
    >
      <CandidateDuplicateScanProcessLayout onCancelAction={redirectCallback} />
    </UpdateForm>
  );
};

export default CandidateDuplicateScanProcessPage;
